<template>
    <div>
    <b-modal ref="vat-payment" :title="$t('accounting.account.vatEnterPayment')"
             @ok="saveVat"
             :ok-title="$t('action.save')"
             :no-close-on-backdrop="true"
             :no-close-on-esc="true">
        <div class="">
            <Loading2 style="" v-if="processing"/>
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col col-12">
                            <div class="form-group">
                                Мулклар: <strong>{{vatPay.evaluationObjectIds}}</strong>
                            </div>
                            <div class="form-group">
                                <label>Жами: </label>
                                <span class="bold-row">{{vatPay.total | currency('', 2, { thousandsSeparator: ' ' })}}</span>
                            </div>
                            <div class="form-group">
                                <label>{{$t("accounting.account.date")}}<span class="red">*</span></label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="vatPay.date"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="form-group">
                                <label>Тўлов топширикномасини киритинг<span class="red">*</span></label>
                                <textarea class="form-control"
                                          v-model="vatPay.vatPaidPaymentOrder">
                        </textarea>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </div>
    </b-modal>
    </div>
</template>

<script>

    import initFilterModel from '@/shared/filter';
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {format_date} from '@/shared/utils';
    import Datepicker from 'vuejs-datepicker';
    import Loading2 from '@/views/Loading2';
    import {formatDate, /*parseDate*/} from '@/shared/utils';


    export default {
        name: "VatPayment",
        components: {
            'b-modal': bModal,
            Datepicker,
            Loading2
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                filter: initFilterModel(),
                show: false,
                processing: false,
                numericTypes: numericTypes,
                vatPay: {
                    total: 0,
                    date: null,
                    evaluationObjectIds: [],
                    objectType: null,
                    vatPaidPaymentOrder: null
                },
            }
        },
        methods: {
            format_date(value){
                if (value) {
                    return format_date(value)
                }
                return null;
            },
            saveVat(){
                const vm = this;

                if (this.vatPay.date && this.vatPay.evaluationObjectIds.length>0 && this.vatPay.vatPaidPaymentOrder) {
                    this.vatPay.date = formatDate(this.vatPay.date);

                    this.$http.post('/payment/vat/save', this.vatPay)
                        .then(res => {
                            vm.processing = false;
                            const response = res.data;
                            if (response.status === 'SUCCESS') {
                                vm.processing = false;
                                console.log(response.status);
                                if (vm.vatPay.objectType==='AutoAndFitment') {
                                    this.$eventBus.$emit('LegalAccountList', {data: null});
                                } else if (vm.vatPay.objectType==='Building') {
                                    this.$eventBus.$emit('LegalAccountingBuilding', {data: null});
                                } else if (vm.vatPay.objectType==='Asset') {
                                    this.$eventBus.$emit('LegalAccountingAsset', {data: null});
                                }
                            }
                        }, err => {
                            vm.processing = false;
                            console.log(err);
                        });
                } else {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: this.$t('accounting.accountMessages.fillAllFields'),
                        type: 'warning'
                    });
                    vm.processing = false;
                }

            }
        },
        created() {
            this.$eventBus.$on('showVatPaymentModal', (data) => {
                const vm = this;
                this.vatPay = data.vatPay;
                setTimeout(() => {
                    vm.$refs['vat-payment'].show();
                }, 100);

            });
        }
    }
</script>

<style scoped>

</style>
